import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button } from "react-md";

import TextBlock from "components/Shared/TextBlock";
import MDialog, { ACTION_APPLY, ACTION_CLOSE } from "components/Shared/MDialog.tsx";
import {
  getMultiFactorMethodsForUser,
} from "requests/profile";
import VerifyTwoFactorSetup from "components/User/2FA/Setup/VerifyTwoFactorSetup";
import SelectTwoFactorSetup from "components/User/2FA/Setup/SelectTwoFactorSetup";

const TwoFactorAuthSetup = (props) => {
  const mounted = useRef(true);
  // Welcome Them
  const [displayWelcomeDialog, setDisplayWelcomeDialog] = useState(true);
  // Get list of available 2fa methods
  const [multiFactorMethods, setMultiFactorMethods] = useState({ data: [], isFetching: false });
  // response from auth server for 2fa setup
  const [multiFactorSetupResponse, setMultiFactorSetupResponse] = useState({ data: null, isFetching: false });
  // Display dialog asking user to confirm cancellation of 2fa setup
  const [displayCancelSetupDialog, setDisplayCancelSetupDialog] = useState(false);

  const { profile, history } = props;

  useEffect(() => {
    if (!multiFactorMethods.data.length && !multiFactorMethods.isFetching) {
      setMultiFactorMethods({ data: [], isFetching: true });
      getMultiFactorMethodsForUser(profile.internetUserId,
        (s) => setMultiFactorMethods({ data: s.multiFactorUserSettingCollection, isFetching: false }),
        null,
        mounted);
    }
    return () => {
      mounted.current = false;
    };
  }, []);

  let refreshMultiFactorMethods = () => {
    setMultiFactorMethods({ data: [], isFetching: false });
  };

  let clearTwoFactorResponse = () => {
    setMultiFactorSetupResponse({ data: null, isFetching: false });
  };

  let cancelSetupActions = () => {
    let actions = [];
    actions.push({ code: ACTION_CLOSE, onClick: () => setDisplayCancelSetupDialog(false), helpText: "Go Back" });
    actions.push({
      code: ACTION_APPLY, onClick: () => {
        history.push("../redirect");
      }, helpText: "Continue"
    });
    return actions;
  };

  return (
    <div className="two-factor">
      <MDialog
        id={"dialog-welcome-setup"}
        title={"Setup Two Factor Authentication"}
        visible={displayWelcomeDialog}
        width={500}>
        <TextBlock field={`To provide additional security, we now require Two Factor Authentication (2FA).`} />
        <br /><br />
        <TextBlock field={`2FA requires you to identify yourself using two different methods to gain access to the system.  The first method is your username & password. The second method will be entering a code that is emailed to you or texted to a phone number you provide.`} />
        <br /><br />
        <TextBlock field={`Proceed to setup your preferred account for the second method of verification..`} />
        <hr />
        <div className="verify-controls">
          <Button raised primary onClick={() => setDisplayWelcomeDialog(false)}>Continue</Button>
        </div>
      </MDialog>
      {!displayWelcomeDialog && !multiFactorSetupResponse.data &&
        <SelectTwoFactorSetup
          setDisplayCancelDialog={setDisplayCancelSetupDialog}
          multiFactorMethods={multiFactorMethods}
          multiFactorSetupResponse={multiFactorSetupResponse}
          setMultiFactorSetupResponse={setMultiFactorSetupResponse}
        />
      }
      {multiFactorSetupResponse.data &&
        <VerifyTwoFactorSetup
          init={true}
          history={history}
          wrapUpAction={() => history.push("../redirect")}
          {...multiFactorSetupResponse}
          clearTwoFactorResponse={clearTwoFactorResponse}
          multiFactorMethods={multiFactorMethods}
          refreshMultiFactorMethods={refreshMultiFactorMethods}
        />
      }

      <MDialog
        id={"dialog-cancel-setup"}
        visible={displayCancelSetupDialog}
        actions={cancelSetupActions()}
        title={"Are you Sure?"}
        width={600}>
        <TextBlock field={`
            Until Two Factor Authentication settings have been finalized, we will continue
            to remind you each time you login. 

            You can also update your Two Factor Authentication settings from your profile. 
            `} />
      </MDialog>
    </div>
  );
};

TwoFactorAuthSetup.propTypes = {
  profile: PropTypes.object,
  returnUrl: PropTypes.object,
  history: PropTypes.object,
};

const mstp = state => ({
  profile: state.user.profile,
  returnUrl: state.user.redirect.returnUrl,
});

export default connect(mstp)(TwoFactorAuthSetup);